import { useEffect, useState } from 'react';

/**
 * useScrolled — returns true once the window scrolls past `threshold` px.
 * Used by Nav to trigger the scrolled glass background state.
 */
export default function useScrolled(threshold = 12) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return scrolled;
}
